import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { getActas } from "./handlers";
import { tableData } from "./tableData";
import { Container, MuniSpinner2, ScreenHeader, Table } from "../../components";
import useActas from "../../api/actas";
import { useActasStore } from "../../store/actasStore";
import { useGeneralAppStore } from "../../store/generalAppStore";
import { isAfter, isBefore, parseISO, subDays, addDays } from "date-fns";
import FilterBar from "../../components/FilterBar";
import { CSVLink } from "react-csv";
import excelLogo from "../../assets/excel-logo.png";
import { Tooltip } from "@mui/material";
import { Button } from "react-bootstrap";
import { UserContext } from "../../context";
import ModalMarcarImpresa from "../../views/modals/ModalMarcarImpresa";
// import BtnsTable from "../../components/BtnsTable";
// import { Form } from "react-bootstrap";
// import InputRangoFecha from "../../components/inputRangoFecha";
// import { UserContext } from "../../context";

const Actas = () => {
  const { actions: ua } = useContext(UserContext);
  const navigate = useNavigate();
  // const [isLoading, setIsLoading] = useState(false);
  // const [actas, setActas] = useState(null);
  const location = useLocation();
  

  const headers = [
    { label: "ID", key: "id" },
    { label: "#Acta", key: "numero_infraccion" },
    { label: "Infraccion", key: "tipo" },
    { label: "Patente", key: "plate" },
    { label: "Localidad", key: "localidad" },
    { label: "Documento", key: "documento_titular" },
  ];

  const { actas, actasFilter, setActasFilter, codigosZonales, codigosForaneos, setActaAImprimir, actaAImprimir,setActas } = useActasStore();
  const { loads, handlerModal } = useGeneralAppStore();
  const { getActas } = useActas();
  const [filtros, setFiltros] = useState({
    tipo: "",
    localidad: "",
    fecha_desde: "",
    fecha_hasta: "",
    codigo_postal: "",
    zonales: "",
    search: "",
  });

  useEffect(() => {
    if (!ua.hasRole("admin") && !ua.hasRole('admin.app') && !ua.hasRole('tribunales')) {
      navigate("/");
    } else {
      //    getActas(location, setActas, setIsLoading);
      //    getActas(setActas, setIsLoading);
      //   }
      if (location.pathname == "/actas-a-chequear") {
        getActas("/actas_a_chequear");
      }
      if (location.pathname == "/actas-notificadas") {
        getActas("/actas_notificadas");
      }
      if (location.pathname == "/actas") {
        getActas("/actas");
      }
      if (location.pathname == "/actas-asignadas-notificadores") {
        getActas("/actas_asignadas");
      }
    }

    return () => {
      setActasFilter(null);
      setActas(null);
    };
  }, []);

  useEffect(() => {
    const actasFiltrados = actas?.filter((acta) => {
      let isInRage = true;
      const fecha = parseISO(acta.fecha_hora.split(" ")[0].split("/").reverse().join("-"));
      const fechaDesde = parseISO(filtros.fecha_desde);
      const fechaHasta = parseISO(filtros.fecha_hasta);
      const ajustarFechaDesde = subDays(fechaDesde, 1);
      const ajustarFechaHasta = addDays(fechaHasta, 1);
      if (filtros.fecha_desde != "" && filtros.fecha_hasta != "") {
        isInRage = isAfter(fecha, ajustarFechaDesde) && isBefore(fecha, ajustarFechaHasta);
      }

      if (filtros.fecha_desde != "" && filtros.fecha_hasta == "") {
        isInRage = isAfter(fecha, ajustarFechaDesde);
      }

      if (filtros.fecha_desde == "" && filtros.fecha_hasta != "") {
        isInRage = isBefore(fecha, ajustarFechaHasta);
      }

      // console.log(codigosZonales)
      // console.log(codigosForaneos)
      let pepe = codigosForaneos;
      if (filtros.zonales != "" && filtros.zonales == "zonales") {
        pepe = codigosZonales;
      }

      // if (
      //   (filtros.zonales != "" ? pepe.includes(acta.codigo_postal) : true) &&
      //   acta.tipo?.includes(filtros.tipo) &&
      //   isInRage &&
      //   acta.plate?.toLowerCase().includes(filtros.search.toLowerCase())
      // ) 
      if (
        // acta.localidad?.includes(filtros.localidad) &&
        (filtros.zonales != "" ? pepe.includes(acta.codigo_postal) : true) &&
        acta.tipo?.includes(filtros.tipo) &&
        isInRage &&
        (
          acta.plate?.toLowerCase().includes(filtros.search.toLowerCase()) ||
          acta?.numero_acta?.toString().toLowerCase().includes(filtros.search.toLowerCase()) ||
          acta?.documento_titular?.toString().toLowerCase().includes(filtros.search.toLowerCase())
        )
      ) {
        return acta;
      }
    });

    setActasFilter(actasFiltrados);
  }, [filtros]);

  // console.log(actas)
  // console.log(actasFilter)
  // console.log(localidades)
  // console.log(filtros)

  // console.log(actasFilter)

  return (
    <Container>
      <ScreenHeader screenHeaderTitle={location.pathname.replaceAll('/', '').replaceAll('-', ' ').toUpperCase()} />
      {/* {isLoading ? ( */}
      {loads.includes("actas") ? (
        <MuniSpinner2 />
      ) : (
        <>
          {actasFilter && (
            // ver de meter store de zustand. Tener dos estados actas y actasFiltradas.
            <>
              {/* <p>Filtros</p> */}
              {/* <Table height={600} data={tableData(actas, location)} name="actas" search /> */}
              <Table
                data={tableData(actasFilter, location, handlerModal, setActaAImprimir)}
                name="actas"
                search
                render={() => (
                  <div className="d-flex w-100 justify-content-between">
                    <Tooltip title="Descargar tabla" arrow>
                      <div className="h-100 d-flex align-items-center ps-3">
                        <CSVLink
                          style={{ textDecoration: "none" }}
                          headers={headers}
                          filename={"listado-actas.csv"}
                          data={actasFilter}
                          separator={";"}
                          disabled={loads?.includes("actas")}
                        >
                          <div
                            className="btn btn-light d-flex gap-2 align-items-center my-auto me-1"
                            style={{ maxHeight: "38px" }}
                          >
                            <span style={{ color: "#111", textDecoration: "nome" }}>
                              Descargar Listado
                            </span>
                            <img
                              src="https://webservice.muninqn.gov.ar/cglobales/assets/icons/Excel-Logo.png"
                              alt="excel"
                              style={{ height: 25 }}
                            />
                          </div>
                          {/* <img src={excelLogo} alt="excel-logo" /> */}
                        </CSVLink>
                      </div>
                    </Tooltip>
                    <FilterBar filtros={filtros} setFiltros={setFiltros} />
                  </div>
                )}
              />
            </>
          )}
        </>
      )}
      <ModalMarcarImpresa />
    </Container>
  );
};
export default Actas;
